<template lang="pug">
.a1content
    //- .pic(:style="{backgroundImage:'url('+getImg()+')'}" v-show="showpic")
    //- video.vid(ref="vid" :src="getVid()" :loop="getLoop()" v-show="showvid" muted="true" autoplay="true" 
    //- :poster="posterimg")
    VidUtil.vidutil(
        ref="vid"
        :src="getVid()"
        :loop="getLoop()"
        width="3840"
        height="2160"
        duration="0.03"
        :endCallBack="vidEnded"
        v-show="showvid"
    )

    
    //- .cont
        //- .hNext2(@click="onclick(1)" :class="this.current===0?'enabled':''")
        //- .hNext(@click="next()")
        //- .hHome(@click="onclick(0)" :class="this.current===1?'enabled':''")
    .contInvis
        .hot(
            v-for="item in hots"
            :style="{backgroundImage:'url(' + item.src + ')',left: pxToRem(item.left),top: pxToRem(item.top), width: pxToRem(item.width), height: pxToRem(item.height)}"
            @click="()=>{onclick(item.cmd,item.args)}"
            :class="{enabled:item.vis.indexOf(current)!==-1,'hotdebug':debug}"
        )
        .hotcn(:style="{backgroundImage:'url(' + cn.src + ')',left: pxToRem(cn.left),top: pxToRem(cn.top), width: pxToRem(cn.width), height: pxToRem(cn.height)}"
                @click="()=>{onclick(cn.cmd,cn.args)}"
                v-show="lang==='en'"
                :class="{enabled:cn.vis.indexOf(current)!==-1,'hotdebug':debug}")
        .hoten(:style="{backgroundImage:'url(' + en.src + ')',left: pxToRem(en.left),top: pxToRem(en.top), width: pxToRem(en.width), height: pxToRem(en.height)}"
                @click="()=>{onclick(en.cmd,en.args)}"
                v-show="lang==='cn'"
                :class="{enabled:en.vis.indexOf(current)!==-1,'hotdebug':debug}")
    .debug(v-if="debug")
        h1 {{current}}


</template>

<script>
// `left: ${item.left*scaler}px; top: ${item.top*scaler}px; width: ${item.width*scaler}px; height: ${item.height*scaler}px;`
//:src="item.src"
import KeyService from '@/services/KeyService'
import VidUtil from '@/utils/VidUtil'
export default {
    components:{
        VidUtil
    },
    data(){
        return {
            debug: window.a1copy.debug,
            datas: window.a1copy.datas,
            hots: window.a1copy.hots,
            path: window.a1copy.path,
            lang: window.a1copy.lang,
            cn: window.a1copy.cn,
            en: window.a1copy.en,
            //[
                // './static/A/K_1_D/1.5.mp4',
                // {'src':'./static/A/A_5/main.jpg'},
                // {'src':'./static/A/A_6/imgs/200g.png'},
                // {'src':'./static/A/A_6/imgs/800g.png'},
                // {'src':'./static/A/A_5/main.mp4','loop':true},
                // {'src':'./static/A/A_5/a5_p2.png'},
                // {'src':'./static/A/A_5/a5_2.mp4','loop':true},
                // {'src':'./static/K/K_1_D/2.mp4','loop':true,'presrc':'./static/K/K_1_D/1.5.mp4'},
                // {'src':'./static/K/K_1_D/3.mp4','loop':true,'presrc':'./static/K/K_1_D/2.5.mp4'},
                // './static/A/K_1_D/2.5.mp4',

            //],
            // hots:[
            //     {left: 1263, top: 56, width: 138, height: 127,link: 1,vis: "0"},
            //     {left: 1263, top: 56, width: 138, height: 127,link: 2,vis: "1"},
            //     {left: 1263, top: 56, width: 138, height: 127,link: 3,vis: "2"},
            //     {left: 1463, top: 56, width: 138, height: 127,link: 0,vis:"0_1_2_3"},
            // ],
            posterimg: '',
            current: 0,
            lastpic: 0,
            lastvid: 2,
            playPreVid: 0,//prevideo,only play once
            loopFalseMode: 0,//0:stop,1:play next
            
        }
    },
    computed:{
        showpic(){console.log(this.datas)
            return (this.datas[this.current].src.indexOf('.jpg')!=-1||this.datas[this.current].src.indexOf('.png')!=-1)
        },
        showvid(){//console.log("showvid:"+(this.datas[this.current].src.indexOf('.mp4')!=-1))
            return (this.datas[this.current].src.indexOf('.mp4')!=-1)
        },

    },
    created(){
        
    },
    mounted(){
        KeyService.getInstance().n.add(this.next.bind(this))
        KeyService.getInstance().p.add(this.prev.bind(this))
// import jsondata from './static/A/A_1/A_1.json'
        
        // this.$fetch('static/tabs.json').then(response => {
        //     console.log(response)
        //     this.editableTabs = response.data
        //     this.tabIndex = this.editableTabs.length
        // }).catch(err => {
        //     console.log(err)
        // })

    },
    methods:{
        next(){
            this.current = (this.current +1)%this.datas.length
            this.playPreVid=0
        },
        prev(){
            this.current = (this.current -1+this.datas.length)%this.datas.length
            this.playPreVid=0
        },
        home(){
            this.current = 0
            this.playPreVid=0
        },
        replay(){
            this.$refs.vid.replay()
        },
        vidEnded(){
            console.log('ended',this.current)
            if(this.loopFalseMode===0?this.playPreVid===1:this.playPreVid===1||this.playPreVid===0)
                this.current = (this.current+1)%this.datas.length
            else this.playPreVid=1

        },
        getImg(){
            if(this.datas[this.current].src.indexOf('.jpg')!=-1||this.datas[this.current].src.indexOf('.png')!=-1){
                this.lastpic=this.current
            }
            return this.datas[this.lastpic].src
        },
        getVid(){
            if(this.datas[this.current].src.indexOf('.mp4')!=-1){
                this.lastvid=this.current
            }else return ""
            if(this.datas[this.lastvid].presrc&&this.playPreVid!=1){
                this.playPreVid=2
                this.posterimg=this.datas[this.lastvid].posterimg
                return this.datas[this.lastvid].presrc
            }
            this.posterimg=this.datas[this.lastvid].posterimg
            // return this.datas[this.lastvid].src
            return this.path+this.lang+'/'+this.datas[this.lastvid].src
        },
        getLoop(){
            if(this.playPreVid===0||this.playPreVid===1)return this.datas[this.current].loop
            else return false
        },
        onclick(cmd,args){
            if(cmd==="back"){
                this.current = args
                this.playPreVid=0
              //this.$router.replace(val)
              //this.changeName(val)
                console.log('hot clk:'+(args))
            }else if(cmd==="next") this.next()
            else if(cmd==="prev") this.prev()
            else if(cmd==="home") this.home()
            else if(cmd==="replay") this.replay()
            else if(cmd==="cn") this.lang="cn"
            else if(cmd==="en") this.lang="en"
        },
        pxToRem(px){
            return `${px/14*0.5}rem`
        },
        
    }

}
</script>

<style lang="sass" scoped>
@import '@/styles/common'
.a1content
    // background-color: red
    .debug
        position: absolute
        font-size: pxToRem(100)
        color: white
        top: pxToRem(20)
        left: pxToRem(20)
    +full()
    .vid
        +full()
        object-fit: cover
    .pic
        width: 100%
        height: 100%
        // background-color: red
        background-size: contain
        background-repeat: no-repeat
        background-position: center
    .smallvid
        position: absolute
        top: pxToRem(1000)
        left: pxToRem(1000)
        width: pxToRem(1000)
    // .hot
    //     background-color: red
    //     position: absolute
    //     pointer-events: all
    //     // opacity: 0
    //     cursor: pointer
    //     display: none
    //     &.enabled
    //         display: block
    // .cont
    //     position: absolute
    //     left: 0
    //     top: 0
        
    
    //     .hNext2
    //         position: absolute
    //         top: pxToRem(1000)
    //         left: pxToRem(1420)
    //         width: pxToRem(450)
    //         height: pxToRem(620)
    //         // background: red
    //         background-repeat: no-repeat
    //         background-size: cover
    //         cursor: pointer
    //         display: none
    //         &.enabled
    //             display: block
    //     .hNext
    //         position: absolute
    //         top: pxToRem(2000)
    //         left: pxToRem(3700)
    //         width: pxToRem(100)
    //         height: pxToRem(100)
    //         background-image: url("~@/assets/icon/next.png")
    //         background-repeat: no-repeat
    //         background-size: cover
    //         cursor: pointer
    //     .hHome
    //         position: absolute
    //         top: pxToRem(100)
    //         left: pxToRem(3500)
    //         width: pxToRem(150)
    //         height: pxToRem(150)
    //         background-image: url("~@/assets/icon/home.png")
    //         background-repeat: no-repeat
    //         background-size: cover
    //         cursor: pointer
    //         display: none
    //         &.enabled
    //             display: block
    .contInvis
        position: absolute
        top: 0
        display: inline-flex
        .hot,.hotcn,.hoten
            // margin: pxToRem(10)
            position: absolute
            background-repeat: no-repeat
            background-size: contain
            object-fit: contain
            cursor: pointer
            display: none
            &.enabled
                display: block
        .hotdebug
            background-color: red
            opacity: .5
</style>